import React, { useRef, useEffect } from 'react'
import Picture from './Picture'

const DualImageHover = ({ image1, image2 }) => {

	const containerEl = useRef(null)
	const maskEl = useRef(null)
	const mainImageEl = useRef(null)
	let imageX = 0
	let imageW = 0

	useEffect(() => {
		const rect = containerEl.current.getBoundingClientRect()
		imageX = rect.x
		imageW = rect.width
	})

	const handleMouseMove = e => {
		if (localStorage.getItem('is-touch') === 'true') return;
		const x = imageW - (e.clientX - imageX);
		maskEl.current.style.transform = `translate3d(${-x}px, 0, 0)`
		mainImageEl.current.style.transform = `translate3d(${x}px, 0, 0)`
	}

	const handleMouseLeave = e => {
		if (localStorage.getItem('is-touch') === 'true') return;
		maskEl.current.style.transform = `none`
		mainImageEl.current.style.transform = `none`
	}

	return (
		<div
			className="DualImageHover"
			onMouseMove={handleMouseMove}
			onMouseLeave={handleMouseLeave}
			ref={containerEl}
		>
			<div
				className="DualImageHover__Mask"
				ref={maskEl}
			>
				<img
					src={image1.fluid.src}
					srcSet={image1.fluid.src}
					alt={image1.alt}
					sizes="(max-width: 414px) and (min-height: 500px) 100vw, 46.18vw"
					className="DualImageHover__ImageMain"
					ref={mainImageEl}
				/>
			</div>
			<img
				src={image2.fluid.src}
				srcSet={image2.fluid.src}
				alt={image2.alt}
				size="46.18vw"
				className="DualImageHover__ImageBehind"
			/>
		</div>
	)

}

export default DualImageHover